import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { of } from 'rxjs';
import { FrattaleService } from './frattale.service';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends FrattaleService{

  /* url: string = ''
  remoteUrl: string = '' */

  private dataOperative: any
  private dataReportM12: any

  constructor(@Inject(HttpClient) protected http: HttpClient) {
    super(http)
  }

  delAllOrders() {
    return this.http.post(this.url, { action: 'ordini', cmd: 'delAllOrders' })
  }

  setOrdiniGiorno(id: number) {
    return this.http.post(this.url, { action: 'ordini', cmd: 'setOrdini', idgiorno: id })
  }

  getReports(d: number) {
    return this.http.post(this.url, { action: 'reports', giorno: d })
  }

  getMarkets() {
    return this.http.post(this.url, { action: 'markets' })
  }

  marketsStorico() {
    return this.http.post(this.url, { action: 'markets', cmd: 'storico' })
  }

  storicoStrategy(mkt: string, verso: string) {
    return this.http.post(this.url, { action: 'report_strategy', market: mkt, verso: verso })
  }

  addStrategyPref(id: number, market: any, verso: any) {
    return this.http.post(this.url, { action: 'strategy_pref', cmd: 'add', id: id, mkt: market, verso: verso })
  }

  deleteStrategyPref(id: number) {
    return this.http.post(this.url, { action: 'strategy_pref', cmd: 'delete', id: id })
  }

  listStrategyPref() {
    return this.http.post(this.url, { action: 'strategy_pref', cmd: 'list' })
  }

  listaStrategyTS(id: number){
    return this.http.post(this.url, {action: 'strategy_pref', cmd: 'reportts', id: id})
  }

  addTsPref(id: number){
    return this.http.post(this.url, {action: 'trading_systems', cmd: 'add', id: id})
  }

  listaTS(){
    return this.http.post(this.url, {action: 'trading_systems', cmd: 'list'})
  }

  disableTS(id: number, enabled: any){
    return this.http.post(this.url, {action: 'trading_systems', cmd: 'disable', id: id, enabled: enabled})
  }

  deleteTS(id: number){
    return this.http.post(this.url, {action: 'trading_systems', cmd: 'delete', id: id})
  }

  analisiTS(id: number, mkt: any, verso: any, limitLevel: any, tp: any, tp_oc: any, limitSL: any, limit_onclose: any , stop_onzero: any){
    let p = {
      action: 'trading_systems',
      cmd: 'analisi',
      id: id,
      mkt: mkt,
      verso: verso,
      limitLevel: limitLevel,
      takeProfit: tp,
      tp_oc: tp_oc,
      limitSL: limitSL,
      limit_onclose: limit_onclose,
      stop_onzero: stop_onzero
    }
    return this.http.post(this.url, p)
  }

  elaboraHistoryStrategy() {
    return this.http.post(this.url, { action: 'strategy_test' })
  }

  strategyOperative() {
    if(this.dataOperative){
      return of (this.dataOperative)
    }
    return this.http.post(this.url, { action: 'operative' })
  }

  setDataOperative(dataOperative: any) {
    this.dataOperative = dataOperative
  }

  setOrdine(id: string, rep: any) {
    return this.http.post(this.url, { action: 'ordini', cmd: 'add', id: id, ord: rep })
  }

  delOrdine(id: number) {
    return this.http.post(this.url, { action: 'ordini', cmd: 'del', id: id })
  }

  abilita(id: string) {
    return this.http.post(this.url, { action: 'ordini', cmd: 'abilita', id: id })
  }

  disabilita(id: string) {
    return this.http.post(this.url, { action: 'ordini', cmd: 'disabilita', id: id })
  }

  listaOrdini() {
    return this.http.post(this.url, { action: 'ordini', cmd: 'lista' })
  }

  setVolume(id: number, vol: any) {
    return this.http.post(this.url, { action: 'ordini', cmd: 'setVolume', id: id, volume: vol })
  }

  lastValues(market: string, ora: null) {
    if (window.location.hostname.indexOf('localhost') < 0) {
      market = market.toUpperCase()
    }
    console.log(market)
    return this.http.post(this.url, { action: 'lastvalues', market: market, ora: ora })
  }

  getTransa(market: string) {
    let post = {
      account: '1516482',
      action: 'transa',
      cmd: 'lista'
    }
    if (market != 'Tutti') {
      let post = {
        account: '1516482',
        action: 'transa',
        market: market,
        cmd: 'lista'
      }
    }
    return this.http.post(this.url, post)
  }

  getListaOrderMarkets() {
    let post = { action: 'transa', account: '1516482', cmd: 'markets' }
    return this.http.post(this.url, post)
  }

  updateReports_pp_m12(mkt: any, del: boolean=false) {
    return this.http.post(this.url, { action: 'update_reports_m12', market: mkt, delete: del})
  }

  report_market(market: any, giorno: any, pattern: any, orap: any, orac: any) {
    let p = { action: 'report_market', market: market, giorno: giorno, pattern: pattern, orap: orap, orac: orac }
    console.log(p)
    return this.http.post(this.url, p)
  }

  report_pp_m12() {
    return this.http.post(this.url, { action: 'reports_pp_m12' })
  }

  report_m12() {
    if(this.dataReportM12){
      return of (this.dataReportM12)
    }
    return this.http.post(this.url, { action: 'reports_m12' })
  }

  addPref(id: number) {
    return this.http.post(this.url, { action: 'reports_pref', 'cmd': 'add', id: id })
  }

  deletePref(id: any) {
    return this.http.post(this.url, { action: 'reports_pref', 'cmd': 'delete', id: id })
  }

  listaPref() {
    return this.http.post(this.url, { action: 'reports_pref', 'cmd': 'lista' })
  }

  backtest(market: string) {
    return this.http.post(this.url, { action: 'backtester', cmd: 'bt', market: market })
  }

  backtestMarkets() {
    return this.http.post(this.url, { action: 'backtester', cmd: 'lista' })
  }

  listaBT() {
    return this.http.post(this.url, { action: 'backtester', cmd: 'lista' })
  }

  verificaPP() {
    return this.http.post(this.url, { action: 'test_pp' })
  }

  verificaPO() {
    return this.http.post(this.url, { action: 'test_po' })
  }

  getGiorno(id: number) {
    switch (id) {
      case 2:
        return "Lunedì"
      case 3:
        return "Martedì"
      case 4:
        return "Mercoledì"
      case 5:
        return "Giovedì"
      case 6:
        return "Venerdì"
      default: //NUOVO COMANDO SWITCH
        return "Tutti"
    }
  }

  realTime(mkt: any, h: any, w: any, p: any, c: any){
    return this.http.post(this.url ,{action: 'real-time', mkt: mkt, h: h, w: w, p: p, c: c})
  }

  cambioeuro(mkt: any){
    return this.http.post(this.url ,{action: 'cambioeuro', market: mkt})
  }

}
